var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18V18.5C3 19.0525 3.4475 19.5 4 19.5H16.5C17.6045 19.5 18.5 18.5575 18.5 17.3945V2.6055C18.5 1.4425 17.6045 0.5 16.5 0.5H4C3.4475 0.5 3 0.9475 3 1.5V4M3 10V12M3 14V16M3 6V8M7.5 8H12.5M1 4H4M1 8H4M1 12H4M1 16H4M15 5H7.5",
    stroke: "#061F40",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.91fda21c29b036e7ac8be374ee265e2d.svg";
export { ForwardRef as ReactComponent };